import { render, staticRenderFns } from "./DesignRirekisho002Edit.vue?vue&type=template&id=28d7e068&scoped=true"
import script from "./DesignRirekisho002Edit.vue?vue&type=script&lang=js"
export * from "./DesignRirekisho002Edit.vue?vue&type=script&lang=js"
import style0 from "./DesignRirekisho002Edit.vue?vue&type=style&index=0&id=28d7e068&prod&lang=scss&scoped=true"
import style1 from "./DesignRirekisho002Edit.vue?vue&type=style&index=1&id=28d7e068&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d7e068",
  null
  
)

export default component.exports